import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { answerSurvey } from "../../../../store/thubMethods";
import styles from "../../../../styles/Survey.module.scss";
import { ComponentLoader } from "../../../ui/common/LoadingSpinner";

const SurveyBox = ({ data, currentQuest, setCurrentQuest, index }) => {
  const [selectedChoices, setSelectedChoices] = useState([]);
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data?.length !== 0 && data?.length === selectedChoices.length) {
      setIsLoading(true);
      dispatch(answerSurvey(selectedChoices)).then(() => {
        setIsLoading(false);
        setSubmitted(true);
      });
    }
  }, [selectedChoices]);

  const handleChoiceClick = (item) => {
    setSelectedChoices([
      ...selectedChoices,
      { question: data[currentQuest]?.id, answer: item.id },
    ]);
    setCurrentQuest(currentQuest + 1);
  };

  if (submitted) {
    return (
      <div>
        <h3 className="mb-3">Thank you for participating in our survey.</h3>
        <Link to={"/survey"} className="btn btn-primary">
          Click here for more surveys
        </Link>
      </div>
    );
  }

  return (
    <>
      {isLoading ? (
        <ComponentLoader className="mt-4 mt-md-0">
          <p className="m-0">
            <em>Please wait while we are submitting your survey form.</em>
          </p>
        </ComponentLoader>
      ) : (
        <>
          Process {currentQuest + 1}/{data?.length}
          <div className={styles.questionCont}>
            <h5 className="mb-4">
              {currentQuest + 1 + ") "}
              {data[currentQuest]?.question &&
                data[currentQuest]?.question + "?"}
            </h5>
            <ul className={styles.questionBox}>
              {data &&
                data[currentQuest]?.choices.map((item, i) => (
                  <li
                    onClick={() => {
                      handleChoiceClick(item);
                    }}
                    key={i}
                    className="curosr-pointer"
                  >
                    <label className="me-2">
                      {i === 0
                        ? "a)"
                        : i === 1
                        ? "b)"
                        : i === 2
                        ? "c)"
                        : i === 3
                        ? "d)"
                        : "e"}
                    </label>{" "}
                    <p>{item.choice}</p>
                  </li>
                ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default SurveyBox;
